import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AuthLayoutVue } from './AuthLayoutVue'

export const PageNotFoundVueLayout = observer(() => {
  const { authStore } = useEntitiesContext()

  if (authStore.isLoggedIn) return <AuthLayoutVue />

  return <Outlet />
})
